module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    attrs: {
      "mode": "vertical",
      "theme": "dark",
      "unique-opened": true,
      "default-openeds": _vm.defaultOpeneds,
      "default-active": _vm.$route.path
    }
  }, [_c('sidebar-item', {
    attrs: {
      "routes": _vm.permission_routers
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b723828"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/Sidebar.vue
// module id = 1748
// module chunks = 1